import React, { Component } from 'react';
import { Grid, Button, Divider, Tab, Table, Input } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { PtDateInput, PtInput, PtSelect, TextSelect } from '../grit-utilities';
import DropdownLib from '../DropdownLib';
import '../index.css';
import $ from 'jquery';
import config from '../config.json';

export default class StockManager extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Id: 0,
            activeIndex: 0,
            disable: true,
            edit: false,
            editBtnDisable: false,
            typeOptions: [],
            typeOptionsDesc: [],
            PanelCode: null,
            AvailableShopStock: null,
            TotalInstalled: null,
            stockTable: [],
            searchTerm: '',
            sortKey: 'TotalInstalled',
            sortDirection: 'descending'
        }
        const header = {
            fontWeight: "bold",
            fonstSize: "1em"
        }
        const addzone = {
            marginTop: '15px'
        }

        const calender = {
            marginLeft: '20px'
        }
        const border = {
            border: '1px solid rgba(34, 36, 38, .15)'
        }

        this.panes = [
            {
                menuItem: 'Sign Stock', render: () =>
                    <Tab.Pane>
                        <Table compact="very" style={{ 'border': 'None', marginBottom: 0 }}>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell > <TextSelect
                                        width={"100px"}
                                        options={this.state.typeOptions} id="num"
                                        label="Sign Type #"
                                        onChange={this.onInputChange}
                                        placeholder="Enter Sign"
                                        name="PanelCode" disabled={this.props.disabled} /></Table.Cell>

                                    <Table.Cell > <TextSelect
                                        width={"200px"}
                                        options={this.state.typeOptionsDesc} id="desc"
                                        label="Description"
                                        onChange={this.onInputChange}
                                        placeholder="Enter Sign Description"
                                        name="PanelCode" disabled={this.props.disabled} /></Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>

                        <Table compact="very">
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell style={header}>Sign Stock</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell  ><div style={calender}>Total Installed</div></Table.Cell>
                                    <Table.Cell  >Available Stock</Table.Cell>
                                </Table.Row>
                                <Table.Row>

                                    <Table.Cell><div style={calender}>
                                        <PtInput disabled={true} name="TotalInstalled" placeholder="Total Installed"
                                            value={this.state.TotalInstalled == null ? '' : this.state.TotalInstalled} />
                                    </div>
                                    </Table.Cell>
                                    <Table.Cell >
                                        <PtInput disabled={this.state.disable} name="AvailableShopStock" placeholder="Sign Stock"
                                            value={this.state.AvailableShopStock == null ? '' : this.state.AvailableShopStock}
                                            onChange={this.onInputChange} />
                                    </Table.Cell>

                                </Table.Row>

                            </Table.Body>
                        </Table>
                    </Tab.Pane>
            },
            {
                menuItem: 'Stock Table', render: () =>
                    <Tab.Pane style={{ paddingTop: '10px', paddingLeft: '0px', paddingRight: '0px', paddingBottom: '0px' }}>
                        <Input
                            icon="search"
                            placeholder="Search Sign..."
                            value={this.state.searchTerm}
                            onChange={this.handleSearchChange}
                        />
                        <div style={{ height: '450px', overflowY: 'auto', paddingTop: '4px' }}>
                            <Table sortable celled structured compact="very">
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell textAlign='center'
                                            sorted={this.state.sortKey === 'SignDesc' ? this.state.sortDirection : null}
                                            onClick={() => this.handleSort('SignDesc')}
                                        >
                                            Sign
                                        </Table.HeaderCell>
                                        <Table.HeaderCell textAlign='center'
                                            sorted={this.state.sortKey === 'TotalInstalled' ? this.state.sortDirection : null}
                                            onClick={() => this.handleSort('TotalInstalled')}
                                        >
                                            Installed
                                        </Table.HeaderCell>
                                        <Table.HeaderCell textAlign='center'
                                            sorted={this.state.sortKey === 'AvailableShopStock' ? this.state.sortDirection : null}
                                            onClick={() => this.handleSort('AvailableShopStock')}
                                        >
                                            Stock
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {this.getFilteredAndSortedData().map((row, index) => (
                                        <Table.Row key={index} style={border}>
                                            <Table.Cell textAlign='center'>{row.SignDesc}</Table.Cell>
                                            <Table.Cell textAlign='center'>{row.TotalInstalled}</Table.Cell>
                                            <Table.Cell textAlign='center'>{row.AvailableShopStock}</Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </div>
                    </Tab.Pane >
            }
        ];
    }

    handleSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value });
    }

    handleSort = (sortKey) => {
        const { sortKey: currentSortKey, sortDirection } = this.state;
        let direction = 'ascending';
        if (currentSortKey === sortKey && sortDirection === 'ascending') {
            direction = 'descending';
        }
        this.setState({ sortKey, sortDirection: direction });
    }

    getFilteredAndSortedData = () => {
        const { stockTable, searchTerm, sortKey, sortDirection } = this.state;
        const filteredData = stockTable.filter(row => {
            return row.SignDesc.toLowerCase().includes(searchTerm.toLowerCase());
        });

        return filteredData.sort((a, b) => {
            if (a[sortKey] < b[sortKey]) return sortDirection === 'ascending' ? -1 : 1;
            if (a[sortKey] > b[sortKey]) return sortDirection === 'ascending' ? 1 : -1;
            return 0;
        });
    }

    editClick = () => {
        this.setState({
            disable: !this.state.disable,
            edit: !this.state.edit,
            editBtnDisable: !this.state.editBtnDisable
        });
    }

    cancelClick = () => {
        this.setState({
            disable: !this.state.disable,
            edit: !this.state.edit,
            editBtnDisable: !this.state.editBtnDisable
        });
    }


    render() {
        const btnClass = {
            marginTop: '5px'
        }

        return (
            <div>
                <Grid.Row>
                    <h5>Sign Stock Manager</h5>
                </Grid.Row>
                <Divider />
                <Grid.Row>
                    <Tab panes={this.panes} activeIndex={this.state.activeIndex} onTabChange={this.onTabChange} />
                </Grid.Row>
                {this.state.activeIndex == 0 &&
                    <div>
                        {this.state.edit && <Button style={btnClass} size='tiny' onClick={this.clickSave} color='green'>Save</Button>}
                        {this.props.loggedin && <Button style={btnClass} disabled={this.state.editBtnDisable} size='tiny' onClick={this.editClick} color={this.state.edit ? 'yellow' : 'green'}>Edit</Button>}
                        {this.state.edit && <Button style={btnClass} size='tiny' onClick={this.cancelClick}>Cancel</Button>}
                    </div>
                }

            </div>
        );
    }

    onTabChange = (e, data) => {
        this.updateActiveIndex(data.activeIndex);
        if (data.activeIndex == 1) {
            this.getShopStockTable();
        } else if (this.state.PanelCode) {
            this.setupPanelCode(this.state.PanelCode)
        }
    }

    updateActiveIndex = (activeIndex) => {
        this.setState({ activeIndex: activeIndex });
    }

    clickSave = () => {
        let stockData = this.state;
        if (!stockData.PanelCode) {
            alert("Please select Sign Type or Description")
        }
        else {
            this.props.handleLoadingOpen(true);
            let finalData = {
                Id: stockData.Id,
                AgencyId: this.props.agencyId,
                PanelCode: parseInt(stockData.PanelCode),
                AvailableShopStock: parseInt(stockData.AvailableShopStock)
            };
            console.log('Final Data ', finalData)

            $.ajax({
                type: 'POST',
                url: `${config.server}\\savesignshopstock`,
                contentType: 'application/json',
                data: JSON.stringify(finalData),

                success: (data) => {
                    console.log('Success data ', data)
                    this.props.handleLoadingOpen(false);
                    if (data && data.data) {
                        this.setState({ Id: data.data });
                    }
                    this.cancelClick();
                },
            });

        }
    }


    onInputChange = (e) => {
        const { target } = e
        const { name, value } = target
        if (name === 'PanelCode') {
            var input = e.target,
                list = input.getAttribute('list'),
                options = document.querySelectorAll('#' + list + ' option[value="' + input.value + '"]'),
                hiddenInput = document.getElementById('PanelCode-hidden'),
                inputVal = input.value

            hiddenInput.value = inputVal
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                if (option.value === inputVal) {
                    hiddenInput.value = option.getAttribute('data-value');
                    this.setupPanelCode(hiddenInput.value);
                    break;
                }
            }
        } else {
            const isInteger = /^-?\d*$/.test(value);
            isInteger &&
                this.setState({ [name]: value });
        }
    }

    setupPanelCode = (val) => {
        this.setState({ PanelCode: val }, () => {
            let panelCode = this.state.PanelCode;
            if (panelCode === null) return;

            var inputs = document.getElementsByClassName("CodeInput");
            var types = this.state.typeOptions;
            var desc = this.state.typeOptionsDesc;

            for (var x = 0; x < types.length; x++) {
                if (types[x].value === parseInt(panelCode)) {
                    inputs[0].value = types[x].label;
                }
            }

            for (var x = 0; x < desc.length; x++) {
                if (desc[x].value === parseInt(panelCode)) {
                    inputs[1].value = desc[x].label;
                }
            }

            if (this.props.agencyId && panelCode) {
                this.getSignShopStock(panelCode);
            }
        });
    };


    getSignShopStock(panelCode) {
        fetch(`${config.server}/getsignshopstock/${this.props.agencyId}/${panelCode}`)
            .then(response => {
                return response.json();
            })
            .then(data => {
                this.setState({
                    Id: data.Id,
                    AvailableShopStock: data.AvailableShopStock,
                    TotalInstalled: data.TotalInstalled
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    getShopStockTable() {
        fetch(`${config.server}/gethopstocktable/${this.props.agencyId}`)
            .then(response => {
                return response.json();
            })
            .then(data => {
                data && data.data && data.data.length > 0 &&
                    this.setState({
                        stockTable: data.data[0]
                    });
            })
            .catch(error => {
                console.log(error);
            });
    }

    componentDidMount() {
        const { typeOptions } = DropdownLib.getSignNum().Signs_Types;
        const { typeOptions: typeOptionsDesc } = DropdownLib.getSignTypeDesc().Signs_Types;
        this.setState({ typeOptions: typeOptions, typeOptionsDesc: typeOptionsDesc });
    }
}



// WEBPACK FOOTER //
// ./src/layers/stockmanager.js